import { Entity, stringifyEntityRef } from '@backstage/catalog-model';
import { useEntity } from '@backstage/plugin-catalog-react';
import { Container } from '@backstage/ui';
import { AccessReportLoader } from './AccessReportLoader';

const PRINCIPAL_TYPES = ['azure-managed-identity', 'azure-app-registration'];

/** The entities that have an "Azure access" tab. */
export function hasAzureAccess(entity: Entity): boolean {
  const kind = entity.kind.toLocaleLowerCase('en-US');
  const type = String(entity.spec?.type ?? '');
  return (
    kind === 'user' ||
    kind === 'group' ||
    kind === 'system' ||
    (kind === 'resource' &&
      (PRINCIPAL_TYPES.includes(type) || type === 'azure-resource-group'))
  );
}

export const EntityAzureAccessContent = () => {
  const { entity } = useEntity();
  const entityRef = stringifyEntityRef(entity);
  return (
    <Container>
      <AccessReportLoader
        load={api => api.getForEntity(entityRef)}
        deps={[entityRef]}
      />
    </Container>
  );
};
